import React from 'react';
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
} from 'recharts';

export const GraphMultiWorkTooltip = ({ active, payload, valueSuffix = '' }) => {
    if (!active || !payload?.length) {
        return null;
    }
    return (
        <div style={{ backgroundColor: '#fff', padding: '10px', border: '1px solid #ccc', borderRadius: '4px' }}>
            {payload
                .filter((entry) => entry.value !== null && entry.value !== undefined)
                .map((entry, index) => (
                    <p key={index} style={{ color: entry.color, margin: '5px 0' }}>
                        {`${entry.name}: ${entry.value}${valueSuffix}`}
                    </p>
                ))}
        </div>
    );
};

const MultiWorkLineChart = ({
    chartData,
    series,
    yDomain = ['auto', 'auto'],
    valueSuffix = '',
    gridStroke,
    minChartWidth = 750,
    height = 300,
}) => (
    <div
        style={{
            width: '100%',
            maxWidth: '100%',
            minWidth: 0,
            overflowX: 'auto',
            overflowY: 'hidden',
            WebkitOverflowScrolling: 'touch',
        }}
    >
        <div style={{ width: '100%', minWidth: minChartWidth, height }}>
            <ResponsiveContainer width="100%" height="100%">
                <LineChart data={chartData} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
                    <XAxis dataKey="name" minTickGap={20} />
                    <YAxis domain={yDomain} />
                    <CartesianGrid strokeDasharray="3 3" stroke={gridStroke} />
                    <Tooltip content={<GraphMultiWorkTooltip valueSuffix={valueSuffix} />} />
                    {series.length > 1 && (
                        <Legend
                            wrapperStyle={{
                                maxWidth: '100%',
                                overflowX: 'auto',
                                paddingTop: 8,
                            }}
                        />
                    )}
                    {series.map((item) => (
                        <Line
                            key={item.key}
                            type="monotone"
                            dataKey={item.key}
                            name={item.label}
                            stroke={item.color}
                            dot={false}
                            connectNulls
                            strokeWidth={2}
                            isAnimationActive={false}
                        />
                    ))}
                </LineChart>
            </ResponsiveContainer>
        </div>
    </div>
);

export default MultiWorkLineChart;
